"use client";

import { c as _c } from "react/compiler-runtime";
import { Avatar } from "@mantine/core";
import { AccountDrawer } from "@/features/account";
import { SidebarMenu, SidebarMenuItem, useSidebarLayout } from "@/layouts/app-shell/sidebar-layout";
import { cn, getInitials } from "@/lib/utils";
import type { Profile } from "@/features/auth/api/types";
import classes from "./account-navigation.module.scss";
interface AccountNavigationProps {
  user: Profile;
  isLoading?: boolean;
  panelOpen: boolean;
  onPanelOpenChange: (open: boolean) => void;
}
interface AccountNavigationButtonProps {
  name: string;
  avatarSrc?: string;
  avatarFallback: string;
  onClick: () => void;
}
function AccountNavigationButton(t0) {
  const $ = _c(25);
  const {
    name,
    avatarSrc,
    avatarFallback,
    onClick
  } = t0;
  const {
    showCollapsedVisual,
    isMobile,
    phase
  } = useSidebarLayout();
  const isCollapsed = isMobile ? false : showCollapsedVisual;
  const isClosing = !isMobile && phase === "menu-out";
  const showText = !isCollapsed || phase === "menu-out";
  const t1 = isClosing && classes.buttonClosing;
  const t2 = !isClosing && isCollapsed && classes.buttonCollapsed;
  const t3 = !isClosing && !isCollapsed && classes.buttonExpanded;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = cn(classes.button, t1, t2, t3);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isClosing && classes.innerClosing;
  const t6 = !isClosing && isCollapsed && classes.innerCollapsed;
  const t7 = !isClosing && !isCollapsed && classes.innerExpanded;
  let t8;
  if ($[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
    t8 = cn(classes.inner, t5, t6, t7);
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      root: classes.avatar,
      image: classes.avatarImage,
      placeholder: classes.avatarPlaceholder
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== avatarFallback || $[10] !== avatarSrc || $[11] !== name) {
    t10 = <Avatar src={avatarSrc} alt={name} radius="md" classNames={t9}>{avatarFallback}</Avatar>;
    $[9] = avatarFallback;
    $[10] = avatarSrc;
    $[11] = name;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== isClosing || $[14] !== name || $[15] !== showText) {
    t11 = showText && <div className={cn(classes.text, isClosing && classes.textClosing)}><span className={classes.name}>{name}</span></div>;
    $[13] = isClosing;
    $[14] = name;
    $[15] = showText;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t8) {
    t12 = <div className={t8}>{t10}{t11}</div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== onClick || $[22] !== t12 || $[23] !== t4) {
    t13 = <button type="button" className={t4} onClick={onClick}>{t12}</button>;
    $[21] = onClick;
    $[22] = t12;
    $[23] = t4;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}
export function AccountNavigation(t0) {
  const $ = _c(17);
  const {
    user,
    isLoading,
    panelOpen,
    onPanelOpenChange
  } = t0;
  const name = user.streamingUsername ?? user.name ?? "";
  let t1;
  if ($[0] !== name) {
    t1 = getInitials(name);
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initials = t1;
  const t2 = user.saMetadata?.thumbnailUrl;
  let t3;
  if ($[2] !== onPanelOpenChange) {
    t3 = () => onPanelOpenChange(true);
    $[2] = onPanelOpenChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== initials || $[5] !== name || $[6] !== t2 || $[7] !== t3) {
    t4 = <SidebarMenu><SidebarMenuItem><AccountNavigationButton name={name} avatarSrc={t2} avatarFallback={initials} onClick={t3} /></SidebarMenuItem></SidebarMenu>;
    $[4] = initials;
    $[5] = name;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isLoading || $[10] !== onPanelOpenChange || $[11] !== panelOpen || $[12] !== user) {
    t5 = <AccountDrawer open={panelOpen} onOpenChange={onPanelOpenChange} profile={user} isLoading={isLoading} />;
    $[9] = isLoading;
    $[10] = onPanelOpenChange;
    $[11] = panelOpen;
    $[12] = user;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}